import { render } from "./ObjModel.vue?vue&type=template&id=1c40ce9d&scoped=true"
import script from "./ObjModel.vue?vue&type=script&lang=js"
export * from "./ObjModel.vue?vue&type=script&lang=js"

import "./ObjModel.vue?vue&type=style&index=0&id=1c40ce9d&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c40ce9d"]])

export default __exports__